import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

import * as styles from './BackButton.css';

function BackButton(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Button
      className={styles.backButton}
      exact={true}
      link={'/'}
      prefix={<FontAwesomeIcon icon={faChevronLeft} />}
      type={'naked'}
    >
      {t('Back to login')}
    </Button>
  );
}

export default BackButton;
